import { render, staticRenderFns } from "./UiControlComponent.vue?vue&type=template&id=3aa59502&"
import script from "./UiControlComponent.vue?vue&type=script&lang=ts&"
export * from "./UiControlComponent.vue?vue&type=script&lang=ts&"
import style0 from "./UiControlComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports